export function getRemainderTime(startTime) {
  const s2 = parseInt(new Date().getTime() / 1000)
  let runTime = startTime - s2
  const day = Math.floor(runTime / 86400)
  runTime = runTime % 86400
  const hour = Math.floor(runTime / 3600)
  runTime = runTime % 3600
  const minute = Math.floor(runTime / 60)
  return {
    day,
    hour,
    minute
  }
}

export function checkPhoneNumber(phone) {
  const reg = /^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,7,8]|8[0-9]|9[1,8,9])\d{8}$/
  if (!reg.test(phone) || !phone.length === 11) {
    return false
  }
  return true
}

export function getIsIOS() {
  return /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase())
}

export function getUrlMap() {
  const url = window.location.href
  const map = {}
  if (url.indexOf('?') !== -1) {
    const baseStr = url.split('?')[1]
    const reArr = baseStr.split('&')
    reArr.forEach(item => {
      const [key, value] = item.split('=')
      map[key] = value
    })
  }
  return map
}

export function uuid() {
  const s = []
  const hexDigits = '0123456789abcdef'
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'
  return s.join('').replace(/-/g, '')
}
